import Head from "next/head";
import { renderMetaTags } from "react-datocms";
import { request } from "../lib/datocms";
import HomepageContent from "../components/HomepageContent";
import Footer from "../components/Footer";
import Menu from "../components/Menu";

export default function Home({ data }) {
  return (
    <>
      <Head>{renderMetaTags(data?.homePage?.seo)}</Head>
      <Menu data={data?.menu} />
      <HomepageContent data={data} />
      <Footer data={data?.footer} />
    </>
  );
}

const HOMEPAGE_QUERY = `
query HomePage($isBlank: BooleanType = "") {
  menu(locale: en) {
    aLetterFrom
    menuItems {
      title
      slug
    }
  }
  footer: sponsorMessageFooter(locale: en) {
    termsLink
    privacyLink
    cookiesLink
    sponsorMessage
  }
  homePage(locale: en) {
        seo: _seoMetaTags {
      tag
      content
      attributes
    }

    presents
    aLetterFrom
    contentBlocks {
      ... on LettersFromThumbnailRecord {
        _modelApiKey
        thumbnails
      }
      ... on WordBlockRecord {
        copy
        _modelApiKey
        icon {
          alt
          url
        }
      }
      ... on FeaturedVideoCollectionRecord {
        _modelApiKey
        video {
          title
          videos {
            videoUrl {
              url
              providerUid
              title
            }
          }
        }
      }
    }
    heroVideo {
      url
    }
    heroImage {
      url
      responsiveImage(imgixParams: {auto: format, fit: crop}) {
        src
        title
        alt
        base64
        bgColor
        width
        height
        aspectRatio
      }
    }
  }
  allPages(orderBy: order_ASC, locale: en, filter: { title: {isBlank: $isBlank}}, first: 8) {
    id
    slug
    title
    contentBlocks {
      ... on HeroSectionRecord {
        heroImage {
          responsiveImage(imgixParams: {auto: format, fit: crop}) {
            src
            title
            alt
            base64
            bgColor
            width
            height
            aspectRatio
          }
        }
      }
    }
  }
}
`;

export async function getStaticProps() {
  const data = await request({
    query: HOMEPAGE_QUERY,
  });
  return {
    props: { data },
  };
}
